<template src="./login.html"></template>

<script>
    export default {
        name: 'login',
        data: function() {
            return  {
                username: "",
                password: "",
                errors: []
            };
        },
        methods: {
            login: function() {
                this.axios.post('/api/user/login', {
                    username: this.$data.username,
                    password: this.$data.password
                })
                .then(response => {
                    this.$router.push({path: "/"});
                })
                .catch(e => {
                    if(e.response.status === 422) {
                        this.$data.errors = e.response.data;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import 'login.scss';
</style>


// WEBPACK FOOTER //
// src/components/pages/login/login.vue